var render = function render(){var _vm=this,_c=_vm._self._c;return _c('html',[_vm._v(" 404 Error ")])
}
var staticRenderFns = []

export { render, staticRenderFns }